import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import remove from '../../../../../Res/Icon/remove.png';
import '../EpikBoxObis/BoxObi.css';

class BoxPhones extends Component {
  onBoxEpiDelete = ev => {
    this.props.onPhoneDelete(this.props.phone);
  };

  render() {
    const { phone, BoxPhoneClicked } = this.props;

    return (
      <>
        <div className="boxObiContainer" onClick={() => BoxPhoneClicked(this.props.phone)}>
          <div className="obiLabel">{phone?.number?.number || ''}</div>
          <div className="obiInfo">
            <div className="infoLabel">
              <FontAwesomeIcon fixedWidth className="labelIcon" icon="signature" />
              <h5>Display Name</h5>
            </div>
            <span>{phone.displayName || 'N/A'}</span>
          </div>
          <div className="obiInfo">
            <div className="infoLabel">
              <FontAwesomeIcon fixedWidth className="labelIcon" icon="hashtag" />
              <h5>Extension</h5>
            </div>
            <span>{phone.extension || 'N/A'}</span>
          </div>
          <div className="obiInfo">
            <div className="infoLabel">
              <FontAwesomeIcon fixedWidth className="labelIcon" icon="hashtag" />
              <h5>Model</h5>
            </div>
            <span>{phone.model || 'N/A'}</span>
          </div>
        </div>

        {this.props.user.role === 'superAdmin' ||
        this.props.user.role === 'companyGroupAdmin' ||
        this.props.user.role === 'supportEngineer' ? (
          <div
            className="delete-box-icon"
            onClick={() => {
              this.onBoxEpiDelete();
            }}
          >
            <img
              className="actions-icon"
              style={{
                position: 'relative',
                right: '2.5rem',
                top: '3px',
                height: '20px',
              }}
              src={remove}
              alt="remove"
            />
          </div>
        ) : null}
      </>
    );
  }
}

export default BoxPhones;
